export default __webpack_public_path__ + "static/media/bookmark fan_021126.aadc24e6.png";